import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as ContractsActions from '../../actions/account/actions-contracts';
import { ActionsContracts, SortContractsInit } from '../../actions/account/actions-contracts';
import { Observable, of } from 'rxjs';
import { getContractsInfo } from '../../reducers';
import { select, Store } from '@ngrx/store';
import { ContractsState } from '../../models/account/contracts.state';
import { IContractModel } from '../../models/account/IContractModel';
import { BackendAccountService, sortContracts } from '../../services/backend-account.service';
import { HeaderAlertService } from '@uxdf/direct-shared-lib';
import * as CoreActions from '@uxdf/direct-shared-lib/src/lib/login/core.actions';

@Injectable()
export class EffectsContracts {
  getContracts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ContractsActions.GET_CONTRACTS),
      switchMap(() =>
        this.backendAccountService.getContracts().pipe(
          map((data: IContractModel[]) => {
            data.sort((a, b) => {
              if (a.creationDate > b.creationDate) {
                return -1;
              }
              if (a.creationDate < b.creationDate) {
                return 1;
              }
              return 0;
            });
            return new ContractsActions.GetContractsSuccess(data);
          }),
          catchError(error => {
            if (error && error.error !== undefined && (error.error.code === 40 || error.error.code === 42)) {
              return of(new CoreActions.DirectUserRoleHasBeenChanged());
            } else {
              return of(new ContractsActions.GetContractsError('pageSectionIsNotAvailable'));
            }
          })
        )
      )
    )
  });

  sortContracts$: Observable<ActionsContracts> = createEffect(() => {
    return this.actions$.pipe(
      ofType<ContractsActions.SortContractsInit>(ContractsActions.SORT_CONTRACTS_INIT),
      map((action: SortContractsInit) => {
        const sortingDirection = action.payload;
        let sortedContracts: IContractModel[] = [];
        let currentContracts: IContractModel[];
        this.store.pipe(select(getContractsInfo)).subscribe(st => {
          currentContracts = st.contracts;
          sortedContracts = sortContracts(sortingDirection, currentContracts);
        });
        return new ContractsActions.SortContractsCompleted(sortedContracts);
      })
    )
  });

  constructor(
    private readonly actions$: Actions,
    private readonly http: HttpClient,
    private readonly store: Store<ContractsState>,
    private readonly backendAccountService: BackendAccountService,
    private readonly alert: HeaderAlertService
  ) { }
}
